import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, 
         DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMessageSeverity, 
         DwAction, DwActionType, DwFormActionConfig, DwFormActionConfigDefaultComponent, DwModalService, DwModalConfig, DwModalButtonStandardConfigs, 
         DwModalSize, DwMetaDataFormStateService, DwGridActionResult, DwCacheService, DwMessagingService } from '@devwareapps/devware-cap';
import { map, flatMap, tap, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { AppMetaDataItemNames, PayJobChangeEntity } from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { PayJobChangeApproveActionService } from './pay-job-change-actions-approve.service';
import { PayJobChangeMetaDataItemNames, PayJobChangeMetaDataLookups } from '../meta-data/payjobchange-meta-data.service';
import { PaginationNumberFormatterParams } from 'ag-grid-community/dist/lib/entities/gridOptions';
import { RejectedNotesModalComponent } from '../component/rejected-notes-modal/rejected-notes-modal.component';
import { PayChangeTypeCv } from '../meta-data/constants/pay-change-type-cv.enum';
import { RejectedNotesModalResultModel } from '../models/rejected-notes-modal-result-model';

@DwAction<DwFormActionConfig>({
  isGlobal: false,
  actionType: DwActionType.formAction,
  display: 'Reject',
  keyName: 'reject',
  actionMessage: 'Rejecting...',
  parentItemName: AppMetaDataItemNames.PayJobChange,
  configComponent: DwFormActionConfigDefaultComponent,
  defaultButtonConfig: {
    buttonText: 'Reject',
    buttonTitle: 'Reject',
    command: 'reject',
    iconClass: '',
    buttonClass: 'btn btn-danger'
  },
  configData: {
    redirectAfter: true,
    actionMessage: 'Rejecting...',
  }
})
@Injectable({
  providedIn: 'root'
})
export class PayJobChangeRejectActionService extends PayJobChangeApproveActionService {

  constructor(
    private dwModalService: DwModalService,
    msalHandler: DwSecuritySSOService,
    securityService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) securityRepository: DwSecurityRepositoryService,
    @Inject(DwOrmDataServiceToken) ormDataService: DwOrmDataService,
    cacheService: DwCacheService,
    http: HttpClient,
    messageService: DwMessagingService) {
    super(msalHandler, securityService, securityRepository, ormDataService, cacheService, http, messageService);
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = {
      success: true,
      message: 'Rejected',
      returnAfter: true
    };

    const fancyResult: DwMdFormActionResult = {

      success: true,
      message: {
        messageBody: 'Rejected',
        allowClose: true,
        timeToShow: 5000,
        severity: DwMessageSeverity.warning
      }

    };

    const cannotApproveResult: DwMdFormActionResult = {
      success: false,
      message: 'This is not assigned to you!',
    };

    this.canAssess(false, formActionState).subscribe((ok : boolean) => {
      if (ok)
        PayJobChangeApproveActionService.canRejectErr = null;
      else
        return of(cannotApproveResult);
    });

    return this.rejectedNotesModal(formActionState);
  }

  rejectedNotesModal(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    let modalConfig = new DwModalConfig();

    modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
    modalConfig.allowFullScreen = true;

    modalConfig.component = RejectedNotesModalComponent;
    modalConfig.modalSize = DwModalSize.responsive;

    modalConfig.title = `PAF Pay/Job Change - Rejected Notes`;

    window.scroll(0, 0);

    return this.dwModalService.showModal(modalConfig)
      .pipe(mergeMap(modalResult => {

        const result: DwMdFormActionResult = {
          success: true,
          message: 'Rejected',
          returnAfter: true
        };

        if (modalResult.cancelled) {
          result.cancelled = true;
          return of(result);
        }

        const rejectedNotesModalResults: RejectedNotesModalResultModel = modalResult.data.rejectedNotes;
        const rejectedByModalResults: RejectedNotesModalResultModel = modalResult.data.rejectedByEthos_UserId;

        return this.saveAs(formActionState, result, rejectedNotesModalResults, rejectedByModalResults);
      }));
  }

  saveAs(formActionState: DwMdFormActionState, result, rejectedNotesModalResults, rejectedByModalResults): Observable<DwMdFormActionResult> {

    formActionState.formApi.patchFormData({ StatusCv: PayChangeTypeCv.rejected, RejectedNotes: rejectedNotesModalResults, RejectedByEthos_UserId: rejectedByModalResults });

    const ob = formActionState.formApi.saveData(false)
      .pipe(map(saveResult => {
        if (!saveResult.success) {
          return saveResult;
        }

        return result;
      }));

    return ob;
  }
}
